import { TrustpilotTestimonial } from "components/TrustpilotTestimonial";
import type { TrustpilotTestimonialAdapterProps } from "./TrustpilotTestimonial.d";

const TrustpilotTestimonialAdapter = ({
  blok: { srcDesktop, srcMobile, height, alt, cardDesktopPosition = "left" },
}: TrustpilotTestimonialAdapterProps) => (
  <TrustpilotTestimonial
    srcDesktop={srcDesktop}
    srcMobile={srcMobile}
    height={height}
    alt={alt}
    cardDesktopPosition={cardDesktopPosition}
  />
);

export default TrustpilotTestimonialAdapter;
